import Header from './components/Header';
import HeroSection from './components/HeroSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <RankingSection />
        <UpdatesSection />
        <FeaturesSection />
        <FaqSection />
        <CardsSection />
        <AppSection />
        <AboutSection />
        <IndexSection />
        <TopicsSection />
        <CarouselSection />
        <MediaSection />
        <ContactSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
}